import usePersistentState from "./usePersistentState";

export default function useLastQrConfirmation() {
  return usePersistentState<number>("lastQrConfirmation", Date.now());
}
